import { z } from 'zod';

export const socialNetworkLabels = {
  INSTAGRAM: 'Instagram',
  TIKTOK: 'TikTok',
  X: 'X (antigo Twitter)',
  FACEBOOK: 'Facebook',
  OTHER: 'Outros',
} as const;

export const socialLinkSchema = z
  .object({
    network: z.enum(['INSTAGRAM', 'TIKTOK', 'X', 'FACEBOOK', 'OTHER']),
    name: z.string().trim().max(60).default(''),
    handle: z
      .string()
      .trim()
      .transform((value) => value.replace(/^@/u, ''))
      .pipe(
        z
          .string()
          .min(1, 'Informe o @ da rede social.')
          .max(100)
          .regex(/^[\p{L}\p{N}_.-]+$/u, 'Informe somente o @, sem espaços ou endereço da página.'),
      ),
  })
  .strict()
  .superRefine((value, ctx) => {
    if (value.network === 'OTHER' && !value.name)
      ctx.addIssue({ code: 'custom', path: ['name'], message: 'Informe o nome da rede social.' });
  })
  .transform((value) => ({ ...value, name: value.network === 'OTHER' ? value.name : '' }));

/// Lista ordenada, pequena e opcional; pode haver mais de um perfil da mesma rede.
export const socialLinksSchema = z
  .array(socialLinkSchema)
  .max(20, 'Adicione no máximo 20 redes sociais.');
export type SocialLink = z.infer<typeof socialLinkSchema>;

export function socialLinkLabel(link: SocialLink): string {
  return link.network === 'OTHER' ? link.name : socialNetworkLabels[link.network];
}

/// Destinos fechados: nome e @ de uma rede não listada não permitem deduzir sua URL.
export function socialLinkUrl(link: SocialLink): string | null {
  const handle = encodeURIComponent(link.handle);
  switch (link.network) {
    case 'INSTAGRAM':
      return `https://www.instagram.com/${handle}/`;
    case 'TIKTOK':
      return `https://www.tiktok.com/@${handle}`;
    case 'X':
      return `https://x.com/${handle}`;
    case 'FACEBOOK':
      return `https://www.facebook.com/${handle}`;
    case 'OTHER':
      return null;
  }
}
